import { useEffect, useState } from 'react';
import EmailStage from "./EmailStage/EmailStage";
import ResetStage from "./ResetStage/ResetStage";
import SubmitStage from "./SubmitStage/SubmitStage";
import { resetPass } from "../../../../services/authService";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from 'react-i18next';
import Loader from '../../../../components/Loader/Loader';
import { useSearchParams, useParams, useLocation, useNavigate } from 'react-router-dom';

type Step = 'email' | 'sent' | 'reset';

const ForgotPasswordForm = () => {
    const { t } = useTranslation();
    const { stage } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const [step, setStep] = useState<Step>('email');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const hasOtp = !!searchParams.get('otp');
        const routeWantsReset =
            stage === 'reset' || location.pathname.toLowerCase().endsWith('/reset');

        if (routeWantsReset && hasOtp) {
            setStep('reset');
        } else if (routeWantsReset && !hasOtp) {
            setStep('email');
        }
    }, [stage, searchParams, location.pathname]);

    const resetPassMutation = useMutation({
        mutationFn: async (email: string) => {
            setLoading(true);
            const ok = await resetPass(email);
            return ok;
        },
        onSuccess: (ok: boolean) => {
            setLoading(false);
            if (ok) setStep('sent');
        },
        onError: () => {
            setLoading(false);
            alert(t("forgot_password.fail_msg"));
        },
    });

    const handleEmailSubmit = (email: string) => {
        if (!email) {
            alert(t("forgot_password.missing_email"));
            return;
        }
        resetPassMutation.mutate(email);
    };

    const handleBackToEmail = () => {
        
        setSearchParams({});
        navigate("/login");
    };

    return (
        <>
            {loading && <Loader text={t("forgot_password.loading")} />}
            {step === 'email' && <EmailStage onSubmit={handleEmailSubmit} />}
            {step === 'sent' && <SubmitStage onBack={handleBackToEmail} />}
            {step === 'reset' && <ResetStage onBack={handleBackToEmail} />}
        </>
    );
};

export default ForgotPasswordForm;
